import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ProductViewModal from "./ProductViewModel";

function ProductView({ item, currency }) {
  const [productDetails, setProductDetails] = useState(false);

  const handleClick = () => {
    setProductDetails(true);
  };
  return (
    <>
      <VisibilityIcon
        className="text-yellow-400 cursor-pointer"
        onClick={handleClick}
      />
      <ProductViewModal
        currency={currency}
        item={item}
        productDetails={productDetails}
        setProductDetails={setProductDetails}
      />
    </>
  );
}

export default ProductView;
